<template>
  <div class="play-video page">
    <van-nav-bar
      :title="$t('video.title')"
      class="nav-bar"
      :border="false"
    >
      <template #left>
        <van-icon name="arrow-left" @click="back()" />
      </template>
    </van-nav-bar>

    <div class="player-wrap">
      <video
        ref="videoEl"
        class="native-player"
        controls
        playsinline
        webkit-playsinline
        x5-playsinline
        x5-video-player-type="h5"
        :poster="cover"
      ></video>
    </div>

    <div class="play-content">
      <div class="video-info">
        <span class="video-count">{{ videoInfo.count }}{{ $t('video.num_play') }}</span>
      </div>

      <div class="section-title">
        <span>{{ $t('index.recmonmand') }}</span>
      </div>

      <div class="hotlist">
        <div
          v-for="(v, key) in moreVideoInfo"
          :key="key"
          class="hot-item"
          @click="toPlayVideo(v.id)"
        >
          <img
            :src="mediaUrl(v.vod_pic)"
            alt=""
            referrerpolicy="no-referrer"
            loading="lazy"
          />
          <div class="hot-meta">
            <span>{{ $t('video.play') }}:{{ v.count }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Hls from 'hls.js'

export default {
  data() {
    return {
      videoInfo: {},
      moreVideoInfo: [],
      hls: null,
      isPlay: false,
      timer: null,
      isSee: 0,
    }
  },
  computed: {
    cover() {
      return this.mediaUrl(this.videoInfo.vod_pic)
    },
    playUrl() {
      let url = this.videoInfo.vod_play_proxy || ''
      if (!url && this.$route.query.id) {
        url = `${process.env.NODE_ENV === 'development' ? '' : 'https://d2h0m7gk9kbvfa.cloudfront.net'}/api/video/hls?id=${this.$route.query.id}`
      }
      return url
    },
    directPlayUrl() {
      return this.videoInfo.vod_play_url || ''
    },
  },
  methods: {
    mediaUrl(url) {
      if (!url) return ''
      if (/^https?:\/\//i.test(url)) return url
      const base = process.env.NODE_ENV === 'development' ? '' : 'https://d2h0m7gk9kbvfa.cloudfront.net'
      return url.startsWith('/') ? `${base}${url}` : `${base}/${url}`
    },
    back() {
      this.$router.push({ path: '/Video' })
    },
    disposePlayer() {
      if (this.hls) {
        this.hls.destroy()
        this.hls = null
      }
      const video = this.$refs.videoEl
      if (video) {
        video.onplay = null
        video.onpause = null
        video.pause()
        video.removeAttribute('src')
        video.load()
      }
    },
    initPlayer(useDirect) {
      this.disposePlayer()
      const url = useDirect ? this.directPlayUrl : this.playUrl
      if (!url) return

      const video = this.$refs.videoEl
      if (!video) return

      if (Hls.isSupported()) {
        this.hls = new Hls({
          enableWorker: true,
        })
        this.hls.loadSource(url)
        this.hls.attachMedia(video)
        this.hls.on(Hls.Events.ERROR, (event, data) => {
          if (!data.fatal) return
          if (!useDirect && this.directPlayUrl) {
            this.initPlayer(true)
            return
          }
          this.$toast(`${this.$t('video.play')}失败，请稍后重试`)
          this.disposePlayer()
        })
      } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
        video.src = url
      } else {
        this.$toast('您的浏览器不支持播放')
        return
      }

      video.onplay = () => {
        this.isPlay = true
      }
      video.onpause = () => {
        this.isPlay = false
      }
    },
    loadVideoInfo() {
      return this.$http({
        method: 'get',
        data: { id: this.$route.query.id },
        url: 'video_get_info',
      }).then((res) => {
        if (res.code !== 200 || !res.data) {
          this.$toast(res.msg || '加载失败')
          return
        }
        this.videoInfo = res.data
        this.$nextTick(() => {
          this.initPlayer()
        })
      })
    },
    loadMoreVideos() {
      return this.$http({
        method: 'get',
        url: 'video_get_more_item',
      }).then((res) => {
        if (res.code === 200) {
          this.moreVideoInfo = res.data || []
        }
      })
    },
    toPlayVideo(id) {
      if (!localStorage.getItem('token')) {
        this.$router.push({ path: '/Login' })
        return
      }
      if (String(id) === String(this.$route.query.id)) {
        return
      }
      this.$router.replace({ path: '/PlayVideo', query: { id } })
    },
    checkUserAndLoad() {
      this.$http({
        method: 'get',
        url: 'user_info',
      }).then((res) => {
        if (res.code !== 200) {
          return
        }
        this.isSee = res.data.is_see
        if (res.data.status !== 1) {
          this.$toast(this.$t('video.account_out'))
          localStorage.clear()
          this.$router.push({ path: '/Login' })
          return
        }
        this.loadVideoInfo()
        this.loadMoreVideos()
      })
    },
  },
  watch: {
    '$route.query.id'() {
      this.videoInfo = {}
      this.loadVideoInfo()
    },
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({ path: '/Login' })
      return
    }
    this.checkUserAndLoad()
    this.timer = setInterval(() => {
      const video = this.$refs.videoEl
      if (this.isPlay && this.isSee == 0 && video) {
        const ct = Math.round(video.currentTime || 0)
        if (ct >= 180) {
          video.pause()
          this.$toast(this.$t('video.buy'))
        }
      }
    }, 2000)
  },
  beforeDestroy() {
    this.disposePlayer()
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  },
}
</script>

<style lang="less" scoped>
@import '../../assets/css/base.css';

.play-video {
  background: #f2f2f5;
}

.player-wrap {
  flex-shrink: 0;
  width: 100%;
  background: #000;
}

.native-player {
  width: 100%;
  height: 56vw;
  max-height: 420px;
  display: block;
  background: #000;
  object-fit: contain;
}

.play-content {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.video-info {
  background: #fff;
  padding: 0.9375rem;
}

.video-title {
  margin: 0;
  font-size: 1rem;
  font-weight: 700;
  color: #333;
  line-height: 1.5;
}

.video-count {
  display: inline-block;
  margin-top: 0.5rem;
  color: #8175eb;
  font-size: 0.75rem;
  background: #f2f2f5;
  padding: 0.375rem 0.625rem;
  border-radius: 0.5rem;
}

.section-title {
  padding: 0.75rem 0.9375rem 0.25rem;

  span {
    display: inline-flex;
    align-items: center;
    font-size: 0.9375rem;
    font-weight: 700;
    color: #333;
  }

  span::before {
    content: '';
    display: inline-block;
    width: 0.25rem;
    height: 1rem;
    margin-right: 0.5rem;
    border-radius: 0.25rem;
    background: linear-gradient(180deg, #7d76ef, #d63f8c);
  }
}

.hotlist {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 0 0.625rem 1.25rem;
}

.hot-item {
  position: relative;
  width: calc(50% - 0.25rem);
  border-radius: 0.5rem;
  overflow: hidden;
  margin-bottom: 0.75rem;
  background: #fff;

  img {
    width: 100%;
    height: 6.66667rem;
    object-fit: cover;
    display: block;
  }
}

.hot-meta {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 0.5rem;
  height: 2rem;
  background: rgba(0, 0, 0, 0.55);
  color: #fff;
  font-size: 0.75rem;

  span {
    width: 50%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  span:last-child {
    text-align: right;
  }
}
</style>
